import { createFileRoute, redirect } from '@tanstack/react-router'
import { StatusCodes } from 'http-status-codes'

export const Route = createFileRoute('/(redirects)/.redwood/functions/mux-webhooks')({
  loader: () => {
    throw redirect({ to: '/webhooks/mux-webhooks', statusCode: StatusCodes.MOVED_PERMANENTLY })
  },
})
